import { queryKeys } from '@/lib/query-keys';
import { orgMembersClient } from '@/lib/api/ts-rest';
import type { InvitationDetail } from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';


export type Invitation = InvitationDetail;

export function useInvitation(invitationId: string | undefined) {
  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.organizations.invitation(invitationId),
    queryFn: async () => {
      const res = await orgMembersClient.getInvitation({
        params: { invitationId: invitationId! },
      });
      if (res.status !== 200) throw new Error('Failed to load invitation');
      return res.body;
    },
    enabled: !!invitationId,
  });

  return {
    invitation: data,
    isLoading,
    error,
  };
}
